import BenchlingConfig from 'BenchlingConfig';
import {AntibodyDomainType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ImplementedStaticSchemaInterface} from 'schemas/SchemaConstants';

import {AntibodyComponentType} from '../AntibodyConstants';

export const ANTIBODY_SCHEMA_INTERFACE_ID = 'ssi_antibody';

export enum AntibodyComponentSchemaInterfaceApiId {
  AA_DOMAIN_ID = 'ssi_aadomain',
  DNA_DOMAIN_ID = 'ssi_dnadomain',
  AA_CHAIN_ID = 'ssi_aachain',
  DNA_CHAIN_ID = 'ssi_dnachain',
  AA_PAIR_ID = 'ssi_aapair',
  DNA_PAIR_ID = 'ssi_dnapair',
  ANTIGEN_ID = 'ssi_antigen',
}

// Keep in sync with benchling/antibodies/schema/core/constants.py
export const ANTIBODY_COMPONENT_TYPE_TO_INTERFACE_ID: Record<AntibodyComponentType, string> = {
  [AntibodyComponentType.AA_DOMAIN]: AntibodyComponentSchemaInterfaceApiId.AA_DOMAIN_ID,
  [AntibodyComponentType.DNA_DOMAIN]: AntibodyComponentSchemaInterfaceApiId.DNA_DOMAIN_ID,
  [AntibodyComponentType.AA_CHAIN]: AntibodyComponentSchemaInterfaceApiId.AA_CHAIN_ID,
  [AntibodyComponentType.DNA_CHAIN]: AntibodyComponentSchemaInterfaceApiId.DNA_CHAIN_ID,
  [AntibodyComponentType.AA_PAIR]: AntibodyComponentSchemaInterfaceApiId.AA_PAIR_ID,
  [AntibodyComponentType.DNA_PAIR]: AntibodyComponentSchemaInterfaceApiId.DNA_PAIR_ID,
  [AntibodyComponentType.ANTIGEN]: AntibodyComponentSchemaInterfaceApiId.ANTIGEN_ID,
};

export interface AntibodyDomainSchemaFieldSpec {
  schemaOrInterfaceId: string | null;
  domainType: AntibodyDomainType;
  specificity: string | null;
}

export interface AntibodyChainSchemaFieldSpec {
  schemaOrInterfaceId: string | null;
  label: string;
}

export interface ImplementedAntibodyInterface extends ImplementedStaticSchemaInterface {
  interfaceId: typeof ANTIBODY_SCHEMA_INTERFACE_ID;
  formatId: string;
  domainSchemaFieldSpecs: Array<AntibodyDomainSchemaFieldSpec>;
  chainSchemaFieldSpecs: Array<AntibodyChainSchemaFieldSpec>;
}

export type DraftImplementedAntibodyInterface = Pick<ImplementedAntibodyInterface, 'interfaceId'> &
  Partial<ImplementedAntibodyInterface>;

export function isAntibodyImplementedInterface(
  implementedInterface: ImplementedStaticSchemaInterface
): implementedInterface is ImplementedAntibodyInterface | DraftImplementedAntibodyInterface {
  return ANTIBODY_SCHEMA_INTERFACE_ID === implementedInterface.interfaceId;
}

export function isCompleteImplementedAntibodyInterface(
  implementedInterface: DraftImplementedAntibodyInterface
): implementedInterface is ImplementedAntibodyInterface {
  return (
    implementedInterface.interfaceId === ANTIBODY_SCHEMA_INTERFACE_ID &&
    implementedInterface.formatId != null &&
    implementedInterface.domainSchemaFieldSpecs != null &&
    (!BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_CHAINS || implementedInterface.chainSchemaFieldSpecs != null)
  );
}
